<template>
  <BaseField
    :label-style="labelStyle"
    :label-square="labelSquare"
    :label-top="labelTop"
    :label-class="labelClass"
    :attr="attr"
    :form="form"
    :type="inputType"
    :data-type="dataType"
    :label="label"
    :input-value="inputValue"
    :inner-input="innerInput"
    :input-style="inputStyle"
    :inner-input-position="innerInputPosition"
    :step="step"
    :min="min"
    :max="max"
    @change="handleChangeInput($event)"
  />
</template>

<script lang="ts">
import BaseField from './BaseField.vue';
import { defineComponent, PropType, SetupContext } from 'vue';
import { CssProperties } from 'vue-css-definition';
import { TranslateResult } from 'vue-i18n';
import { MAX_OF_CHANGE_DATE } from '@/coreDomainsModule/constants';

export default defineComponent({
  name: 'NumberField',
  components: { BaseField },
  props: {
    form: {
      type: Object,
    },
    attr: {
      type: String,
      default: '',
    },
    label: {
      type: String as PropType<TranslateResult>,
      default: '',
    },
    inputValue: {
      type: Number,
    },
    dataType: {
      type: String,
    },
    inputType: {
      type: String,
      default: 'number',
    },
    labelTop: {
      type: Boolean,
      default: false,
    },
    labelSquare: {
      type: Boolean,
      default: false,
    },
    labelStyle: {
      type: Object as PropType<CssProperties>,
      defaylt: {},
    },
    innerInput: {
      type: String,
    },
    inputStyle: {
      type: Object as PropType<CssProperties>,
      defaylt: {},
    },
    innerInputPosition: {
      type: String,
    },
    step: {
      type: String,
      default: '1',
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: MAX_OF_CHANGE_DATE,
    },
    labelClass: {
      type: String,
      default: '',
    },
  },
  setup(props, context: SetupContext) {
    const handleChangeInput = (event) => {
      context.emit('change', event);
    };

    return {
      handleChangeInput,
    };
  },
});
</script>
